"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorListProvider_1 = require("../../error/components/ErrorListProvider");
var ErrorToasts_1 = require("../../error/components/ErrorToasts");
var RegisterErrorStoreInHost_1 = require("../../error/components/RegisterErrorStoreInHost");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var UrlParamKeys_1 = require("../../urls/UrlParamKeys");
var UrlSearchFunctions_1 = require("../../urls/UrlSearchFunctions");
var CatalogBrowserCountsQueryWrapper_1 = require("./CatalogBrowserCountsQueryWrapper");
var CatalogBrowserHeader_1 = require("./CatalogBrowserHeader");
var CatalogBrowserPlacePageLayout = /** @class */ (function (_super) {
    __extends(CatalogBrowserPlacePageLayout, _super);
    function CatalogBrowserPlacePageLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogBrowserPlacePageLayout.prototype.render = function () {
        var _this = this;
        return (React.createElement(ErrorListProvider_1.ErrorListProvider, { key: this.props.selectedSubplace },
            React.createElement(RegisterErrorStoreInHost_1.RegisterErrorStoreInHost, { registerErrorStore: this.props.registerErrorStore, unregisterErrorStore: this.props.unregisterErrorStore }),
            React.createElement(ErrorToasts_1.ErrorToasts, null),
            React.createElement(CatalogBrowserCountsQueryWrapper_1.CatalogBrowserCountsQueryWrapper, { textSearch: textSearchFromLocationSearch(this.props.locationSearch) }, function (_a) {
                var databasesCount = _a.databasesCount, tablesCount = _a.tablesCount;
                return React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true },
                    React.createElement(CatalogBrowserHeader_1.CatalogBrowserHeader, { databasesCount: databasesCount, tablesCount: tablesCount, selectedSubplace: _this.props.selectedSubplace }),
                    _this.props.renderExplorerComponent(_this.props.locationSearch));
            })));
    };
    return CatalogBrowserPlacePageLayout;
}(React.Component));
exports.CatalogBrowserPlacePageLayout = CatalogBrowserPlacePageLayout;
function textSearchFromLocationSearch(locationSearch) {
    var paramValuesMap = UrlSearchFunctions_1.searchToParamValuesMap(locationSearch);
    var textArray = paramValuesMap[UrlParamKeys_1.UrlParamKeys.search];
    var textSearch = textArray && textArray.length > 0 ? textArray[0] : null;
    return textSearch;
}
//# sourceMappingURL=CatalogBrowserPlacePageLayout.js.map